import { onAuthEvent as B, removeAuthEvent as F, onIncreaseCartItemEvent as O, onDecreaseCartItemEvent as $, onViewCartEvent as H, removeIncreaseCartItemEvent as z, removeDecreaseCartItemEvent as _, removeViewCartEvent as M, onBeginCheckoutEvent as N, onAddPaymentInfoEvent as G, onAddShippingInfoEvent as J, onPurchaseEvent as Q, removeBeginCheckoutEvent as W, removeAddPaymentInfoEvent as Y, removeAddShippingInfoEvent as K, removePurchaseEvent as X, onApplyListFiltersEvent as Z, removeApplyListFiltersEvent as ee, onLoginLinkRequested as te, removeLoginLinkRequested as ne, onUserRegistered as re, removeUserRegistered as oe, onProductReturnEvent as se, onDownloadReturnLabelEvent as ie, removeProductReturnEvent as ae, removeDownloadReturnLabelEvent as ce, onVirtualPageViewEvent as ue, removeVirtualPageViewEvent as de } from "@fond-of/event";
import { currentLocale as ve } from "@fond-of/locale";
const le = {
  /**
   * Generates a unique identifier to use
   * as class for tracking purpose
   */
  getTrackingDataAttributes: (e) => ({
    "data-cs-track": e
  })
};
/*! js-cookie v3.0.5 | MIT */
function p(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var s in r)
      e[s] = r[s];
  }
  return e;
}
var me = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function h(e, t) {
  function r(n, o, i) {
    if (!(typeof document > "u")) {
      i = p({}, t, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var c = "";
      for (var a in i)
        i[a] && (c += "; " + a, i[a] !== !0 && (c += "=" + i[a].split(";")[0]));
      return document.cookie = n + "=" + e.write(o, n) + c;
    }
  }
  function s(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], i = {}, c = 0; c < o.length; c++) {
        var a = o[c].split("="), v = a.slice(1).join("=");
        try {
          var u = decodeURIComponent(a[0]);
          if (i[u] = e.read(v, u), n === u)
            break;
        } catch {
        }
      }
      return n ? i[n] : i;
    }
  }
  return Object.create(
    {
      set: r,
      get: s,
      remove: function(n, o) {
        r(
          n,
          "",
          p({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return h(this.converter, p({}, this.attributes, n));
      },
      withConverter: function(n) {
        return h(p({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var b = h(me, { path: "/" });
const d = () => typeof window < "u" && typeof window.document < "u", ge = () => !d(), pe = () => d() && window.location.host.startsWith("beta"), he = () => b.get("IS_CANARY") === "true", we = () => b.get("fondof_internal") === "true", fe = () => d() && window.location.host.includes("stage."), _e = () => d() && (window.location.host.includes("dev.") || window.location.host.includes("localhost")), Ee = () => d() && window.location.host.includes("www."), ye = {
  isBrowser: d(),
  isSSR: ge(),
  isBeta: pe(),
  isCanary: he(),
  isInternal: we(),
  isStage: fe(),
  isDev: _e(),
  isProd: Ee()
}, ke = (e) => {
  const t = B(async ({ isLoggedIn: r, customer: s }) => {
    r && await e.user(s.email);
  });
  return () => {
    F(t);
  };
}, l = (e) => e / 100, w = (e) => ({
  item_id: e.sku,
  item_brand: e.concreteProducts[0].attributes.brand,
  price: l(
    e.concreteProducts[0].concreteProductPrices[0].price
  ),
  item_name: e.concreteProducts[0].attributes.model_untranslated,
  item_variant: e.concreteProducts[0].attributes.style_untranslated,
  dimension_10: e.concreteProducts[0].attributes.size,
  quantity: e.quantity
}), m = (e) => {
  var t;
  return ((t = e.cartItems) == null ? void 0 : t.map((r) => w(r))) || [];
}, be = (e) => {
  const t = O(
    ({ cartItem: n, quantity: o }) => {
      e.event({
        ecommerce_ga4: null
      }), e.event({
        event: "add_to_cart",
        ecommerce_ga4: {
          items: [{ ...w(n), quantity: o }]
        }
      });
    }
  ), r = $(
    ({ cartItem: n, quantity: o }) => {
      e.event({
        ecommerce_ga4: null
      }), e.event({
        event: "remove_from_cart",
        ecommerce_ga4: {
          items: [{ ...w(n), quantity: o * -1 }]
        }
      });
    }
  ), s = H(({ cart: n }) => {
    e.event({
      ecommerce_ga4: null
    }), e.event({
      event: "view_cart",
      ecommerce_ga4: {
        items: m(n)
      }
    });
  });
  return () => {
    z(t), _(r), _(r), M(s);
  };
}, Ce = (e) => {
  const t = N(({ cart: o }) => {
    e.event({
      ecommerce_ga4: null
    }), e.event({
      event: "begin_checkout",
      ecommerce_ga4: {
        items: m(o)
      }
    });
  }), r = G(
    ({ cart: o, paymentMethod: i }) => {
      e.event({
        ecommerce_ga4: null
      }), e.event({
        event: "add_payment_info",
        ecommerce_ga4: {
          payment_type: i,
          items: m(o)
        }
      });
    }
  ), s = J(({ cart: o }) => {
    e.event({
      ecommerce_ga4: null
    }), e.event({
      event: "add_shipping_info",
      ecommerce_ga4: {
        items: m(o)
      }
    });
  }), n = Q(({ cart: o, orderReference: i }) => {
    var c;
    e.event({
      ecommerce_ga4: null
    }), e.event({
      event: "purchase",
      transactionProductsSkus: [
        ...new Set(o.cartItems.map((a) => a.sku))
      ],
      ecommerce_ga4: {
        transaction_id: i,
        value: l(o.totals.grandTotal),
        tax: l(o.totals.taxTotal),
        shipping: l(o.totals.shipmentTotal),
        currency: o.currency,
        coupon: ((c = o.discounts[0]) == null ? void 0 : c.code) || null,
        items: m(o)
      }
    }), e.event({
      event: "tt_order",
      tt_content: JSON.stringify(
        o.cartItems.map((a) => ({
          content_id: a.sku,
          content_name: a.concreteProducts[0].attributes.model_untranslated,
          content_category: a.concreteProducts[0].attributes.style_untranslated,
          brand: a.concreteProducts[0].attributes.brand,
          quantity: a.quantity,
          price: l(
            a.concreteProducts[0].concreteProductPrices[0].price
          )
        }))
      )
    });
  });
  return () => {
    W(t), Y(r), K(s), X(n);
  };
}, Ie = (e) => {
  const t = Z(({ listFilters: r }) => {
    for (const [s, n] of Object.entries(r))
      n && n.length && e.event({
        event: `item_list_filter_${s}`,
        item_list_filter_selection: typeof n == "string" ? n : n.toString()
      });
  });
  return () => {
    ee(t);
  };
}, Le = (e) => {
  const t = te(({ source: r }) => {
    const s = r ? `login_link_requested_${r.toLowerCase()}` : "login_link_requested";
    e.event({
      event: s
    });
  });
  return () => {
    ne(t);
  };
}, Pe = (e) => {
  const t = re(({ email: r, source: s }) => {
    const n = s ? `user_registered_${s.toLowerCase()}` : "user_registered";
    e.event({
      event: n,
      email: r
    });
  });
  return () => {
    oe(t);
  };
}, Re = (e) => {
  const t = se(({ reason: s, sku: n }) => {
    e.event({
      event: "product_return",
      return_reason: s,
      product_sku: n
    });
  }), r = ie(
    ({ order: { id: s } }) => {
      e.event({
        event: "download_return_label",
        transaction_id: s
      });
    }
  );
  return () => {
    ae(t), ce(r);
  };
}, Te = (e) => {
  const t = ue(
    ({
      url: r,
      pageType: s,
      version: n,
      currency: o,
      customerEmail: i,
      internalTraffic: c,
      store: a,
      system: v,
      transactionAffiliation: u,
      transactionCurrency: C,
      transactionPayment: I,
      transactionDate: L,
      transactionEntity: P,
      transactionTax: R,
      transactionId: T,
      transactionProducts: g,
      transactionProductsSkus: S,
      transactionShipping: A,
      transactionSubtotal: q,
      transactionTotal: x,
      transactionTotalWithoutShippingAmount: U,
      voucherCode: D
    }) => {
      e.event({
        event: "vpv_general",
        vpv_url: r,
        pageType: s,
        version: n,
        currency: o,
        customerEmail: i,
        internalTraffic: c,
        store: a,
        system: v,
        transactionAffiliation: u,
        transactionCurrency: C,
        transactionPayment: I,
        transactionDate: L,
        transactionEntity: P,
        transactionTax: R,
        transactionId: T,
        transactionProducts: g || [],
        transactionProductsSkus: S || [],
        transactionProductsQuantity: (g == null ? void 0 : g.reduce(
          (j, V) => j += V.quantity,
          0
        )) || 0,
        transactionShipping: A,
        transactionSubtotal: q,
        transactionTotal: x,
        transactionTotalWithoutShippingAmount: U,
        voucherCode: D
      });
    }
  );
  return () => {
    de(t);
  };
}, f = (e) => {
  const t = document.createElement("script");
  if (t.type = "text/javascript", t.async = !0, e(t), !document.querySelector(`script[src="${t.src}"]`))
    return document.head.appendChild(t), t;
}, Se = (e) => f((t) => {
  t.src = `https://www.googletagmanager.com/gtm.js?id=${e}`, t.onload = () => {
    window.dataLayer.push({
      event: "gtm.js",
      "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
      "gtm.uniqueEventId": 0
    });
  };
}), Ae = (e, t, r, s) => {
  r && (window.UC_UI_DOMAINS = {
    crossDomainConsentSharingIFrame: r
  }), f((n) => {
    n.id = "usercentrics-cmp", n.src = "https://app.usercentrics.eu/browser-ui/latest/loader.js", n.setAttribute("data-settings-id", e), n.setAttribute("data-language", ve), t && n.setAttribute("data-ruleset-id", t);
  }), f((n) => {
    n.type = "application/javascript", n.src = "https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js", n.async = !1, n.onload = () => {
      typeof window.uc < "u" && s && window.uc.setServiceAlias(s.serviceAliases || {});
    };
  });
}, E = async (e, t = "SHA-1") => {
  var o;
  const r = await ((o = crypto.subtle) == null ? void 0 : o.digest(
    t,
    qe(xe(e))
  ));
  return Array.from(new Uint8Array(r)).map((i) => i.toString(16).padStart(2, "0")).join("");
}, qe = (e) => new TextEncoder().encode(e), xe = (e) => e.toLowerCase(), Ue = (e) => e.charAt(0).toUpperCase() + e.slice(1), y = () => !!window.dataLayer.find((e) => e.event === "gtm.load"), De = {
  /**
   * Save all called dataLayer pushes before gtm got loaded
   */
  events: [],
  /**
   * Accepts custom event and tracks
   * its value in the dataLayer
   */
  event(e) {
    if (typeof e == "string") {
      this.push({
        event: e
      });
      return;
    }
    this.push(e);
  },
  /**
   * Accepts a custom page type and tracks
   * its value in the dataLayer
   */
  page(e) {
    this.push({
      pageType: e
    });
  },
  /**
   * TODO: Discuss if identifier should be more randomized
   *
   * Generates a unique identifier to use
   * as class for tracking purpose
   */
  getUniqueId: (e, t) => `gtm${Ue(e)}-${t}`,
  /**
   * Generates a SHA1 and SHA256 user ID and tracks
   * the user in the dataLayer
   */
  async user(e) {
    const [t, r] = await Promise.all([
      E(e),
      E(e, "SHA-256")
    ]);
    this.push({
      event: "setUserId",
      externalIdHash: t,
      userId: t,
      userIdv2: r
    });
  },
  loadEvents() {
    const e = setInterval(() => {
      y() && (this.events.forEach((t) => window.dataLayer.push(t)), clearInterval(e));
    }, 500);
  },
  /**
   * Inits the dataLayer, usercentrics script, gtm script
   * and register the analytics events
   */
  init(e) {
    window.dataLayer = window.dataLayer || [];
    const t = (e == null ? void 0 : e.gtmId) && (e == null ? void 0 : e.usercentricsId);
    t && (window.dataLayer.push({
      internalTraffic: ye.isInternal,
      ...e.initialDataLayer
    }), Ae(
      e.usercentricsId,
      e.ucRulesetId,
      e.ucCrossDomainUrl,
      e.ucSdpSettings
    ), window.addEventListener("ucEvent", ({ detail: { type: u } }) => {
      u !== "implicit" && (Se(e.gtmId), this.loadEvents());
    })), t || this.loadEvents();
    const r = be(this), s = Ce(this), n = Te(this), o = ke(this), i = Ie(this), c = Le(this), a = Pe(this), v = Re(this);
    return () => {
      r(), s(), n(), o(), i(), c(), a(), v();
    };
  },
  /**
   * Accepts and event payload and either
   * writes to the dayalayer
   */
  push(e) {
    if (!y()) {
      this.events.push(e);
      return;
    }
    window.dataLayer.push(e);
  }
}, je = () => {
  window.addEventListener("ucEvent", (e) => {
    e.detail && e.detail.event === "consent_status" && e.detail.type === "explicit" && (window.uetq = window.uetq || [], window.uetq.push("consent", "update", {
      ad_storage: e.detail["Microsoft Advertising"] ? "granted" : "denied"
    }));
  });
}, Ve = {
  init: () => {
    je();
  }
}, Be = () => ({
  contentsquare: le,
  google: De,
  microsoftAdvertising: Ve
}), k = Be(), $e = {
  mounted: (e, t) => {
    if (t.value === !1)
      return;
    const r = k.contentsquare.getTrackingDataAttributes(
      t.value
    );
    for (const [s, n] of Object.entries(r))
      e.setAttribute(s, n);
  },
  getSSRProps: (e) => {
    if (e.value !== !1)
      return k.contentsquare.getTrackingDataAttributes(e.value);
  }
};
export {
  Be as Analytics,
  k as default,
  $e as vTracking
};
//# sourceMappingURL=analytics.js.map
